import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { getRegionalColors } from '../utils/regional-colors';

export const themeDefault = getMuiTheme({
  palette: {},
  appBar: {
    height: 57,
    color: getRegionalColors().backgroundColor
  },
  drawer: {
    width: 230,
    color: getRegionalColors().backgroundColor
  },
  button: {
    primaryColor: getRegionalColors().color,
    textTransform: 'capitalize'
  },
  raisedButton: {
    primaryColor: getRegionalColors().color,
    textTransform: 'capitalize'
  },
  tabs: {
    backgroundColor: '#283239',
    textColor: '#ffffff',
    selectedTextColor: '#ffffff'
  },
  inkBar: {
    backgroundColor: '#36c6d3'
  },
  toggle: {
    thumbOnColor: getRegionalColors().color,
    trackOnColor: 'gray'
  }
});

export const themeDarkBlue = getMuiTheme({
  palette: {},
  appBar: {
    height: 57,
    color: getRegionalColors().color
  },
  drawer: {
    width: 230,
    color: getRegionalColors().backgroundColor
  },
  button: {
    primaryColor: getRegionalColors().color,
    textTransform: 'capitalize'
  },
  raisedButton: {
    primaryColor: getRegionalColors().color,
    textTransform: 'capitalize'
  },
  tabs: {
    backgroundColor: '#283239',
    textColor: '#ffffff',
    selectedTextColor: '#ffffff'
  },
  inkBar: {
    backgroundColor: '#36c6d3'
  },
  toggle: {
    thumbOnColor: getRegionalColors().color,
    trackOnColor: 'gray'
  }
});
